import { gql } from '@apollo/client'
import { GTUserSuggestion } from 'gql/types.generated'

export const WITHOUT_USER: GTUserSuggestion = {
  id: 'without-user',
  firstName: 'Without user',
  lastName: '',
  name: '',
  username: ''
}

export const resolvers = {
  Mutation: {
    activateSite(_root: TSFixMe, { siteId }: TSFixMe, { cache }: TSFixMe): null {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'Site',
          id: siteId
        }),
        fragment: gql`
          fragment SiteIsActive on Site {
            isActive
          }
        `,
        data: {
          isActive: true,
          __typename: 'Site'
        }
      })

      return null
    },
    deactivateSite(_root: TSFixMe, { siteId }: TSFixMe, { cache }: TSFixMe): null {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'Site',
          id: siteId
        }),
        fragment: gql`
          fragment SiteIsActive on Site {
            isActive
          }
        `,
        data: {
          isActive: false,
          __typename: 'Site'
        }
      })

      return null
    }
  }
}
